import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CheckupResultsComponent } from './checkup-results.component';

const routes: Routes = [{ path: '', component: CheckupResultsComponent }];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(routes);
